<div class="wallet-data">
  <div class="deposit" [ngClass]="{ 'mod-historic': cssStyle === 'historic' }">
    <div
      class="deposit-padding"
			[ngClass]="{
				'mod-noPadding': address?.getDestinationTag().length > 0 || cssStyle === 'historic'
			}">
      @if (warning?.length > 0) {
        <div class="warning mb-20" role="alert">{{ warning }}</div>
      }
      @if (coin && extraInfo?.length > 0) {
        <div class="warning mb-20" role="alert">{{ extraInfo }}</div>
      }
    </div>
    @if (address?.getDestinationTag().length <= 0) {
      <div class="deposit-qr">
        <qrcode
          class="qr-code"
          [qrdata]="getCode()"
          [width]="200"
          [errorCorrectionLevel]="'H'"
        (click)="openAddress()"></qrcode>
      </div>
    }
  </div>
  <div class="list">
    <bp-input
      [value]="address?.getAddress()"
      [label]="'deposit_address' | translate"
      [readonly]="true"
      readonly
      [disabled]="true"
      [infoTooltipUrl]="getSupportAddressUrl()"
      [infoTooltipDescription]="'crypto_address_format_tooltip' | translate">
      <a
        right
        class="action-button"
        [copyToClipboard]="address?.getAddress()"
        [copyInfo]="'copied_address_to_clipboard' | translate">
        <span class="bpi__icon-clipboard font-size-24"></span>
      </a>
      @if (address?.getDestinationTag()) {
        <bp-input
          [label]="destinationTagLabel() | translate"
          [value]="address?.getDestinationTag()"
          [readonly]="true">
          <a
            right
            class="action-button"
            [copyToClipboard]="address?.getDestinationTag()"
            [copyInfo]="'copied_tag_to_clipboard' | translate">
            <span class="bpi__icon-clipboard font-size-24"></span>
          </a>
        </bp-input>
      }
      <bp-info full>
        <span>{{ "created_at" | translate }}: {{ address?.getGeneratedAt().date() | bp_date }}</span>
        @if (showLastUsed()) {
          <div>
            {{ "last_used_at" | translate }}: {{ address?.getLastUpdated()?.date() | bp_date }}
          </div>
        }
      </bp-info>
    </bp-input>
    @if (address_info?.length > 0) {
      <span class="address-information">{{ address_info | translate }}</span>
    }
    @if (coin) {
      <div class="container-left-right mb-10 font-size-small">
        <div class="mb-20">
          <span class="min-deposit-header-first-section pb-10">
            {{ "wallet_min_deposit_amount" | translate }}
            <a class="min-deposit-header-icon" [target]="'_blank'" [href]="limitsLink">
              <span
                class="bpi__icon-info"
                bp-tooltip="{{ 'tooltip_info_text_min_deposit' | translate }}"
              position="top"></span>
            </a>
          </span>
          <div class="min-deposit-details">
            <span class="mt-10 min-deposit-header-info-text">
              {{ "info_text_deposit_not_credited" | translate }}
            </span>
            <span class="min-deposit-header-amount-info">
              {{
              coin?.getWalletMinDeposit()
              | tradable_precision_symbol: { id: coin?.getId(), ignorePrecision: true }
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="container-left-right font-size-small pt-30 pb-30 border-top-gray">
        <div class="min-deposit-header">{{ "wallet_small_deposit" | translate }}</div>
        <div class="min-deposit-header-amount text-right wallet-details-text-right">
          {{
          coin?.getSmallDeposit()
          | tradable_precision_symbol: { id: coin?.getId(), ignorePrecision: true }
          }}
        </div>
      </div>
      <div class="container-left-right font-size-small pt-30 pb-30 border-top-gray">
        <div class="min-deposit-header">{{ "wallet_small_deposit_fee" | translate }}</div>
        <div class="min-deposit-header-amount text-right wallet-details-text-right">
          {{
          coin?.getSmallDepositFee()
          | tradable_precision_symbol: { id: coin?.getId(), ignorePrecision: true }
          }}
        </div>
      </div>
    }
  </div>
</div>
